<template>
  <div class="topbar flex">
    <div class="fl" >
      <a @click="returnPage">
        <i class="fa-angle-left"></i>
      </a>
    </div>
    <div class="span-title">{{title}}</div>
    <a class="lk-home" @click="returnHome">
      <i class="fa-home"></i>
    </a>
  </div>
</template>

<script>
  export default {
    name: "top",
    props: {
      title: String
    },
    methods: {
      returnPage() {
        this.$router.isBack = true;
        this.$router.go(-1);
      },
      returnHome() {
        this.$router.isBack = false;
        this.$router.push('/home');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/layer2/books/books-top.vue